export const DataSourcesSnippet = `
    dataSources {
        benchmarking {
            ...dataSource
        }
        inboundAnalytics {
            ...dataSource
        }
        listeningTags {
            ...dataSource
        }
        listeningTopics {
            ...dataSource
        }
        socialAnalytics {
            ...dataSource
        }
        paid {
            ...dataSource
        }
        storyQuery {
            ...dataSource
        }
        storyTags {
            ...dataSource
        }
        storyQueryTags {
            ...dataSource
        }
        listeningExplorer {
            ...dataSource
        }
    }
`;

export const DataSourceFragment = `
fragment dataSource on DataSource {
  report
  reportingEngine
  sourceGroup
  filters {
    dimensionLabel
    filter {
      dimensionName
      filterType
      values
      allValues
    }
    filterValueLabels {
      id name
      displayName
    }
  }
  ancillaryFilters {
    dimensionLabel
    filter {
      dimensionName
      filterType
      values
      allValues
      details
    }
    filterValueLabels {
      id name
      displayName
    }

  }
}
`;
